<div class="header">
  <div class="title">Видео лиги</div>
  <div class="filters">
    <mtg-dropdown
      [formControl]="seasonControl"
      [errorVisible]="false"
      label="Сезон"
    >
      <mtg-dropdown-item
        [value]="null"
      >Все</mtg-dropdown-item>
      <mtg-dropdown-item
        *ngFor="let season of seasons"
        [value]="season.id"
      >{{ season.name }}</mtg-dropdown-item>
    </mtg-dropdown>
  </div>
</div>
<div class="news-list">
  <div class="news-item" *ngFor="let item of news">
    <a [routerLink]="getVideoRoute(item.id)" class="video-item">
      <div class="video-icon"><mtg-svg-icon icon="icons-play"></mtg-svg-icon></div>
      <img [src]="item.picture.path">
      <div class="overlay"></div>
      <div class="video-info">
        <div class="tag">{{ item.tag }}</div>
        <div class="title">{{ item.title }}</div>
      </div>
    </a>
  </div>
</div>
<div class="load-more" *ngIf="nextPageVisible">
  <mtg-button
    (click)="loadNextPage()"
  >Загрузить еще</mtg-button>
</div>
